import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { FormsModule } from '@angular/forms';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
// @ts-ignore
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';
import { EmpresaStateService } from '../../services/empresa-state.service';
import {
  EtiquetaPrintService,
  type EtiquetaCampo,
  type EtiquetaLinha,
  type EtiquetaDados,
  type EtiquetaImpressoraInfo,
  type EtiquetaImpressaoContexto
} from '../../services/etiqueta-print.service';

// ─── Interfaces específicas da tela de edição de etiquetas ───────────────────

export interface FonteColuna {
  coluna: string;
  tipo: string;
}

export interface FonteInfo {
  nome: string;
  label: string;
  colunas: FonteColuna[];
}

export interface ConfigLista {
  codconfig: number;
  nome: string;
  larguraMm: number;
  alturaMm: number;
}

// @ts-ignore
@Component({
  selector: 'app-etiqueta-config',
  standalone: true,
  imports: [LoadingIndicatorComponent, CommonModule, FormsModule],
  templateUrl: './etiqueta-config.component.html',
  styleUrl: './etiqueta-config.component.css'
})
export class EtiquetaConfigComponent implements OnInit {

  /** Delegado ao EtiquetaPrintService para não duplicar a lista de fontes. */
  get tipografiasCampo() { return this.printSvc.tipografiasCampo; }
  get fontesZpl() { return this.printSvc.fontesZpl; }

  // Estado da lista
  configs: ConfigLista[]  = [];
  fontes: FonteInfo[]     = [];
  carregando              = false;
  salvando                = false;
  toast: { msg: string; tipo: 'ok' | 'erro' } | null = null;

  impressoras: EtiquetaImpressoraInfo[] = [];
  impressoraSelecionada = '';
  qzConectando = false;
  qzConectado = false;
  qzInstalado: boolean | null = null;
  imprimindo = false;
  modoImpressaoLocal: 'imagem' | 'zpl' | 'html' = 'imagem';

  // Configuração ativa
  codconfigAtual: number | null = null;
  nome     = 'Nova Etiqueta';
  largura  = 100;   // mm (armazenado internamente em mm)
  altura   = 50;    // mm (armazenado internamente em mm)
  dados: EtiquetaDados = this.dadosPadrao();

  // Getters/setters em CM para a UI (1 cm = 10 mm)
  get larguraCm(): number { return +(this.largura / 10).toFixed(2); }
  set larguraCm(v: number) { this.largura = Math.round(v * 10); }

  get alturaCm(): number { return +(this.altura / 10).toFixed(2); }
  set alturaCm(v: number) { this.altura = Math.round(v * 10); }

  // Campo selecionado para edição de propriedades
  campoSelecionado: EtiquetaCampo | null = null;
  linhaSelecionadaId: string | null     = null;

  // Drag and drop de linhas
  dragLinhaIdx: number | null  = null;
  dragOverIdx:  number | null  = null;

  // Drag and drop de campos dentro de uma linha
  dragCampoLinhaId:     string | null = null;
  dragCampoIdx:         number | null = null;
  dragOverCampoLinhaId: string | null = null;
  dragOverCampoIdx:     number | null = null;

  // Preview
  previewHtml: SafeHtml = '';
  PREVIEW_MAX_W     = 290;  // px disponíveis (painel 420px − padding − rulers)
  previewTamanhoReal   = false;
  logoVisivelImpressao = true;   // toggle rápido: oculta logo sem perder config
  /** Rotação efetiva - lê rotacaoImpressao; fallback para imprimirGirado legado (=180°). */
  get rotacaoEfetiva(): number {
    const rotacao = this.normalizarRotacao(this.dados.rotacaoImpressao);
    if (rotacao !== null) return rotacao;
    return this.dados.imprimirGirado ? 180 : 0;
  }
  /** @deprecated compat com template antigo */
  get imprimirGirado(): boolean { return this.rotacaoEfetiva !== 0; }
  set imprimirGirado(v: boolean) { this.dados.imprimirGirado = v; }

  // Modal zoom
  modalZoomAberto  = false;
  modalZoomScale   = 1;

  // Preview com dados reais
  previewNunota: number | null  = null;
  previewCodprod: number | null = null;
  previewCarregando             = false;
  dadosReais: Record<string, Record<string, string>> | null = null;

  constructor(
    private readonly svc: SankhyaGatewayService,
    readonly empresa: EmpresaStateService,
    private readonly sanitizer: DomSanitizer,
    private readonly cdr: ChangeDetectorRef,
    private readonly printSvc: EtiquetaPrintService
  ) {}

  ngOnInit(): void {
    this.carregarLista();
    this.carregarFontes();
    this.impressoraSelecionada = this.printSvc.impressoraSalva;
    this.modoImpressaoLocal = this.printSvc.modoImpressaoSalvo;
    if (this.impressoraSelecionada) void this.buscarImpressoras(false);
  }

  async buscarImpressoras(mostrarErro = true): Promise<void> {
    if (this.qzConectando) return;
    this.qzConectando = true;
    try {
      this.impressoras = await this.printSvc.listarImpressoras();
      this.qzConectado = true;
      this.qzInstalado = true;
      if (!this.impressoras.some(p => p.nome === this.impressoraSelecionada)) {
        const impressoraPadrao = await this.printSvc.impressoraPadraoQz();
        this.impressoraSelecionada = this.impressoras.some(p => p.nome === impressoraPadrao)
          ? impressoraPadrao
          : (this.impressoras[0]?.nome ?? '');
      }
      this.salvarImpressoraSelecionada();

      if (mostrarErro) {
        this.mostrarToast(
          this.impressoras.length ? `${this.impressoras.length} impressora(s) encontrada(s).` : 'Nenhuma impressora encontrada.',
          this.impressoras.length ? 'ok' : 'erro'
        );
      }
    } catch {
      this.qzConectado = false;
      const primeiraFalha = this.qzInstalado !== false;
      this.qzInstalado = false;
      this.impressoras = [];
      if (mostrarErro) {
        if (primeiraFalha) window.alert('QZ n\u00e3o instalado');
        this.mostrarToast('QZ Tray nao instalado. Use o link de download para continuar.', 'erro');
      }
    } finally {
      this.qzConectando = false;
    }
  }

  salvarImpressoraSelecionada(): void {
    this.printSvc.salvarImpressoraSelecionada(this.impressoraSelecionada);
  }

  salvarModoImpressao(): void {
    this.printSvc.salvarModoImpressao(this.modoImpressaoLocal);
    this.atualizarPreview();
  }

  rebuscarQzAposAbrir(): void {
    window.setTimeout(() => void this.buscarImpressoras(), 3000);
  }

  get impressoraAtual(): EtiquetaImpressoraInfo | null {
    return this.impressoras.find(p => p.nome === this.impressoraSelecionada) ?? null;
  }

  get impressoraSuportaZpl(): boolean {
    return this.printSvc.suportaZpl(this.impressoraAtual, this.impressoraSelecionada);
  }

  /** Empacota o estado atual da tela no formato que o EtiquetaPrintService espera. */
  private contextoImpressao(): EtiquetaImpressaoContexto {
    return {
      nome: this.nome,
      largura: this.largura,
      altura: this.altura,
      dados: this.dados,
      dadosReais: this.dadosReais,
      logoVisivelImpressao: this.logoVisivelImpressao,
      rotacaoEfetiva: this.rotacaoEfetiva,
      previewZpl: this.modoImpressaoLocal === 'zpl'
    };
  }

  // ─── Carregamento ──────────────────────────────────────────────────────────

  async carregarLista(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.svc.listarEtiquetaConfigs());
      const body = res?.responseBody ?? res;
      this.configs = (body?.lista ?? []).map((c: any) => ({
        codconfig: Number(c.codconfig),
        nome:      c.nome,
        larguraMm: Number(c.larguraMm),
        alturaMm:  Number(c.alturaMm)
      }));
    } catch (e) {
      this.configs = [];
    }
  }

  async carregarFontes(): Promise<void> {
    try {
      const res: any = await firstValueFrom(this.svc.listarEtiquetaFontes());
      const body = res?.responseBody ?? res;
      this.fontes = (body?.fontes ?? []).map((fonte: FonteInfo) => ({
        ...fonte,
        colunas: [...(fonte.colunas ?? [])].sort((a, b) =>
          a.coluna.localeCompare(b.coluna, 'pt-BR', { sensitivity: 'base', numeric: true })
        )
      }));

      const fonteParceiro = this.fontes.find(fonte =>
        `${fonte.nome} ${fonte.label}`.toUpperCase().includes('TGFPAR')
      );
      if (fonteParceiro) {
        const camposEndereco: FonteColuna[] = [
          { coluna: 'NOMEEND', tipo: 'VARCHAR2' },
          { coluna: 'NOMEBAI', tipo: 'VARCHAR2' },
          { coluna: 'NOMECID', tipo: 'VARCHAR2' },
          { coluna: 'UF_CIDADE', tipo: 'VARCHAR2' },
          { coluna: 'CIDADE_UF', tipo: 'VARCHAR2' }
        ];
        const existentes = new Set(fonteParceiro.colunas.map(coluna => coluna.coluna.toUpperCase()));
        fonteParceiro.colunas.push(...camposEndereco.filter(coluna => !existentes.has(coluna.coluna)));
        fonteParceiro.colunas.sort((a, b) =>
          a.coluna.localeCompare(b.coluna, 'pt-BR', { sensitivity: 'base', numeric: true })
        );
      }
    } catch (e) {
      this.fontes = [];
    }
  }

  async abrirConfig(codconfig: number): Promise<void> {
    this.carregando = true;
    this.campoSelecionado = null;
    this.dadosReais = null;
    try {
      const res: any = await firstValueFrom(this.svc.buscarEtiquetaConfig(codconfig));
      const body = res?.responseBody ?? res;
      const cfg  = body?.config;
      this.codconfigAtual = Number(cfg.codconfig);
      this.nome           = cfg.nome;
      this.largura        = Number(cfg.larguraMm);
      this.altura         = Number(cfg.alturaMm);
      try {
        const parsed = JSON.parse(cfg.dadosJson || '{}');
        this.dados = parsed.linhas ? this.normalizarDados(parsed) : this.dadosPadrao();
      } catch {
        this.dados = this.dadosPadrao();
      }
      this.atualizarPreview();
    } catch (e) {
      this.mostrarToast('Erro ao carregar configuração.', 'erro');
    } finally {
      this.carregando = false;
    }
  }

  novaConfig(): void {
    this.codconfigAtual   = null;
    this.nome             = 'Nova Etiqueta';
    this.largura          = 100;
    this.altura           = 50;
    this.dados            = this.dadosPadrao();
    this.campoSelecionado = null;
    this.dadosReais       = null;
    this.atualizarPreview();
  }

  async salvar(): Promise<void> {
    if (!this.nome.trim()) { this.mostrarToast('Informe um nome para a etiqueta.', 'erro'); return; }
    this.salvando = true;
    try {
      this.dados.rotacaoImpressao = this.rotacaoEfetiva as 0 | 90 | 180 | 270;
      const payload: any = {
        NOME:       this.nome,
        LARGURA_MM: this.largura,
        ALTURA_MM:  this.altura,
        DADOS_JSON: JSON.stringify(this.dados)
      };
      if (this.codconfigAtual) payload.CODCONFIG = this.codconfigAtual;
      const res: any = await firstValueFrom(this.svc.salvarEtiquetaConfig(payload));
      const body = res?.responseBody ?? res;
      if (body?.sucesso) {
        this.codconfigAtual = Number(body.codconfig);
        await this.carregarLista();
        this.mostrarToast('Salvo com sucesso!', 'ok');
      } else {
        this.mostrarToast(body?.erro ?? 'Erro ao salvar.', 'erro');
      }
    } catch (e: any) {
      this.mostrarToast('Erro ao salvar.', 'erro');
    } finally {
      this.salvando = false;
    }
  }

  async excluir(): Promise<void> {
    if (!this.codconfigAtual) return;
    if (!confirm(`Excluir "${this.nome}"?`)) return;
    try {
      await firstValueFrom(this.svc.excluirEtiquetaConfig(this.codconfigAtual));
      this.novaConfig();
      await this.carregarLista();
      this.mostrarToast('Excluído.', 'ok');
    } catch {
      this.mostrarToast('Erro ao excluir.', 'erro');
    }
  }

  // ─── Preview com dados reais ────────────────────────────────────────────────

  async carregarDadosReais(): Promise<void> {
    if (!this.codconfigAtual) {
      this.mostrarToast('Salve a configuração antes de carregar dados reais.', 'erro');
      return;
    }
    const codemp = Number(this.empresa.selecionada ?? '1');
    this.previewCarregando = true;
    try {
      const res: any = await firstValueFrom(
        this.svc.buscarDadosImpressaoEtiqueta(
          this.codconfigAtual,
          codemp,
          this.previewNunota ?? undefined,
          this.previewCodprod ?? undefined
        )
      );
      const body = res?.responseBody ?? res;
      if (body?.sucesso) {
        // Normaliza chaves para UPPERCASE para bater com o que o backend retorna
        this.dadosReais = {};
        for (const fonte of Object.keys(body.dados ?? {})) {
          this.dadosReais[fonte.toUpperCase()] = {};
          for (const col of Object.keys(body.dados[fonte])) {
            this.dadosReais![fonte.toUpperCase()][col.toUpperCase()] = body.dados[fonte][col];
          }
        }
        if (this.previewNunota) {
          await this.associarDadosDaVendaAoPreview(this.previewNunota);
        }
        this.atualizarPreview();
        this.mostrarToast('Dados reais carregados.', 'ok');
      } else {
        this.mostrarToast(body?.erro ?? 'Erro ao carregar dados.', 'erro');
      }
    } catch (e: any) {
      this.dadosReais = null;
      this.atualizarPreview();
      this.mostrarToast(e?.message ?? 'Erro ao carregar dados reais.', 'erro');
    } finally {
      this.previewCarregando = false;
    }
  }

  private async associarDadosDaVendaAoPreview(nunota: number): Promise<void> {
    const resposta: any = await firstValueFrom(
      this.svc.consultarOrcamentoImpressao({ NUNOTA: nunota })
    );
    const body = resposta?.responseBody ?? resposta;
    const orcamento = body?.orcamento ?? body?.responseBody?.orcamento;

    if (!body?.sucesso || !orcamento) {
      throw new Error(body?.erro ?? body?.statusMessage ?? `Pedido ${nunota} nao encontrado.`);
    }

    if (!this.dadosReais) this.dadosReais = {};
    const cabecalho = this.dadosReais['TGFCAB'] ??= {};
    for (const [chave, valor] of Object.entries(orcamento)) {
      if (valor !== null && valor !== undefined && typeof valor !== 'object') {
        cabecalho[chave.toUpperCase()] = String(valor);
      }
    }

    const parceiro = this.dadosReais['TGFPAR'] ??= {};
    const aliases: Record<string, string[]> = {
      CODPARC: ['CODPARC', 'CODCLIENTE'],
      NOMEPARC: ['NOMEPARC', 'PARCEIRO'],
      RAZAOSOCIAL: ['RAZAOSOCIAL', 'NOMEPARC', 'PARCEIRO'],
      CGC_CPF: ['CGC_CPF', 'CNPJ', 'CGC', 'DOCPARC'],
      IDENTINSCESTAD: ['IDENTINSCESTAD', 'IE'],
      EMAIL: ['EMAIL', 'EMAILPARC'],
      TELEFONE: ['TELEFONE', 'FONE'],
      NOMEEND: ['NOMEEND', 'ENDERECO'],
      ENDERECO: ['NOMEEND', 'ENDERECO'],
      NUMEND: ['NUMEND', 'NUMERO'],
      COMPLEMENTO: ['COMPLEMENTO', 'COMPLEND'],
      NOMEBAI: ['NOMEBAI', 'BAIRRO'],
      BAIRRO: ['NOMEBAI', 'BAIRRO'],
      NOMECID: ['NOMECID', 'CIDADE'],
      CIDADE: ['NOMECID', 'CIDADE'],
      UF: ['UF'],
      CEP: ['CEP']
    };

    for (const [destino, candidatos] of Object.entries(aliases)) {
      const origem = candidatos.find(chave => {
        const valor = orcamento[chave];
        return valor !== null && valor !== undefined && String(valor).trim() !== '';
      });
      if (origem) parceiro[destino] = String(orcamento[origem]);
    }

    const cidade = parceiro['NOMECID'] || parceiro['CIDADE'] || '';
    const uf = parceiro['UF'] || '';
    const cidadeUf = [uf, cidade].filter(Boolean).join(' - ');
    if (cidadeUf) {
      parceiro['UF_CIDADE'] = cidadeUf;
      parceiro['CIDADE_UF'] = [cidade, uf].filter(Boolean).join(' - ');
      parceiro['NOMECID_UF'] = [cidade, uf].filter(Boolean).join(' - ');
    }
  }

  limparDadosReais(): void {
    this.dadosReais = null;
    this.atualizarPreview();
  }

  // ─── Manipulação de linhas e campos ────────────────────────────────────────

  adicionarLinha(): void {
    const linha: EtiquetaLinha = { id: this.novoId(), campos: [], alturaLinha: 0 };
    this.dados.linhas.push(linha);
    this.atualizarPreview();
  }

  removerLinha(linhaId: string): void {
    this.dados.linhas = this.dados.linhas.filter(l => l.id !== linhaId);
    if (this.linhaSelecionadaId === linhaId) {
      this.linhaSelecionadaId = null;
      this.campoSelecionado   = null;
    }
    this.atualizarPreview();
  }

  onDragStart(idx: number): void {
    this.dragLinhaIdx = idx;
  }

  onDragOver(event: DragEvent, idx: number): void {
    event.preventDefault();
    this.dragOverIdx = idx;
  }

  onDrop(idx: number): void {
    if (this.dragLinhaIdx === null || this.dragLinhaIdx === idx) {
      this.dragLinhaIdx = null;
      this.dragOverIdx  = null;
      return;
    }
    const linhas = [...this.dados.linhas];
    const [removed] = linhas.splice(this.dragLinhaIdx, 1);
    linhas.splice(idx, 0, removed);
    this.dados.linhas = linhas;
    this.dragLinhaIdx = null;
    this.dragOverIdx  = null;
    this.atualizarPreview();
  }

  onDragEnd(): void {
    this.dragLinhaIdx = null;
    this.dragOverIdx  = null;
  }

  onDragStartCampo(event: DragEvent, linhaId: string, idx: number): void {
    event.stopPropagation();
    this.dragCampoLinhaId = linhaId;
    this.dragCampoIdx     = idx;
  }

  onDragOverCampo(event: DragEvent, linhaId: string, idx: number): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOverCampoLinhaId = linhaId;
    this.dragOverCampoIdx     = idx;
  }

  onDropCampo(event: DragEvent, linhaId: string, idx: number): void {
    event.stopPropagation();
    if (this.dragCampoLinhaId !== linhaId || this.dragCampoIdx === null || this.dragCampoIdx === idx) {
      this.resetDragCampo(); return;
    }
    const linha = this.dados.linhas.find(l => l.id === linhaId);
    if (!linha) { this.resetDragCampo(); return; }
    const campos = [...linha.campos];
    const [removed] = campos.splice(this.dragCampoIdx, 1);
    campos.splice(idx, 0, removed);
    linha.campos = campos;
    this.resetDragCampo();
    this.atualizarPreview();
  }

  onDragEndCampo(): void { this.resetDragCampo(); }

  private resetDragCampo(): void {
    this.dragCampoLinhaId     = null;
    this.dragCampoIdx         = null;
    this.dragOverCampoLinhaId = null;
    this.dragOverCampoIdx     = null;
  }

  moverLinhaAcima(idx: number): void {
    if (idx === 0) return;
    const tmp = this.dados.linhas[idx - 1];
    this.dados.linhas[idx - 1] = this.dados.linhas[idx];
    this.dados.linhas[idx]     = tmp;
    this.atualizarPreview();
  }

  moverLinhaAbaixo(idx: number): void {
    if (idx >= this.dados.linhas.length - 1) return;
    const tmp = this.dados.linhas[idx + 1];
    this.dados.linhas[idx + 1] = this.dados.linhas[idx];
    this.dados.linhas[idx]     = tmp;
    this.atualizarPreview();
  }

  adicionarCampo(linha: EtiquetaLinha, tipo: 'campo' | 'texto_livre'): void {
    const total = linha.campos.length + 1;
    const pctBase = Math.floor(100 / total);
    linha.campos.forEach(c => c.larguraPct = pctBase);
    const campo: EtiquetaCampo = {
      id:           this.novoId(),
      tipo,
      fonte:        tipo === 'campo' ? (this.fontes[0]?.nome ?? '') : undefined,
      coluna:       tipo === 'campo' ? (this.fontes[0]?.colunas[0]?.coluna ?? '') : undefined,
      valor:        tipo === 'texto_livre' ? 'Texto' : undefined,
      label:        '',
      mostrarLabel: false,
      alinhamento:  'esquerda',
      negrito:      false,
      italico:      false,
      tamanhoFonte: 10,
      tipografia:   'Arial',
      fonteZpl:     '0',
      larguraPct:   100 - linha.campos.reduce((a, c) => a + c.larguraPct, 0)
    };
    linha.campos.push(campo);
    this.selecionarCampo(linha.id, campo);
    this.atualizarPreview();
  }

  removerCampo(linha: EtiquetaLinha, campoId: string): void {
    linha.campos = linha.campos.filter(c => c.id !== campoId);
    if (this.campoSelecionado?.id === campoId) this.campoSelecionado = null;
    this.redistribuirLarguras(linha);
    this.atualizarPreview();
  }

  selecionarCampo(linhaId: string, campo: EtiquetaCampo): void {
    this.linhaSelecionadaId = linhaId;
    this.campoSelecionado   = campo;
  }

  onFonteChange(campo: EtiquetaCampo): void {
    const fonte = this.fontes.find(f => f.nome === campo.fonte);
    campo.coluna = fonte?.colunas[0]?.coluna ?? '';
    this.atualizarPreview();
  }

  redistribuirLarguras(linha: EtiquetaLinha): void {
    if (!linha.campos.length) return;
    const pct = Math.floor(100 / linha.campos.length);
    linha.campos.forEach((c, i) =>
      c.larguraPct = i === linha.campos.length - 1
        ? 100 - pct * (linha.campos.length - 1)
        : pct
    );
  }

  // ─── Preview ───────────────────────────────────────────────────────────────

  atualizarPreview(): void {
    this.previewHtml = this.sanitizer.bypassSecurityTrustHtml(this.printSvc.gerarHtml(this.contextoImpressao(), false));
    this.cdr.markForCheck();
  }

  get previewScale(): number {
    if (this.previewTamanhoReal) return 1;
    const mmToPx  = 3.7795;
    const labelPx = this.largura * mmToPx;
    return Math.min(this.PREVIEW_MAX_W / labelPx, 6);
  }

  /** Tamanho do conteúdo (sem padding) do container de preview.
   *  O CSS adiciona padding:4px, então o box total fica +8px em cada eixo. */
  get previewContainerH(): number {
    return this.altura  * 3.7795 * this.previewScale;
  }

  get previewContainerW(): number {
    return this.largura * 3.7795 * this.previewScale;
  }

  /** Marcas de centímetro para as réguas laterais do preview. */
  get alturaRulerCms(): number[] {
    const maxCm = Math.floor(this.altura / 10);
    return Array.from({ length: maxCm + 1 }, (_, i) => i);
  }

  /** Gera HTML completo da etiqueta (preview e impressão). Delegado ao EtiquetaPrintService. */
  gerarHtml(modoImpressao: boolean, logoSrc = 'assets/logo_global.png'): string {
    return this.printSvc.gerarHtml(this.contextoImpressao(), modoImpressao, logoSrc);
  }
  abrirZoom(): void {
    const mmToPx  = 3.7795;
    const labelW  = this.largura * mmToPx;
    const labelH  = this.altura  * mmToPx;
    const maxW    = window.innerWidth  * 0.80 - 64;   // desconta padding do modal
    const maxH    = window.innerHeight * 0.78 - 80;   // desconta header/footer
    this.modalZoomScale  = Math.min(maxW / labelW, maxH / labelH, 14);
    this.modalZoomAberto = true;
  }

  fecharZoom(): void {
    this.modalZoomAberto = false;
  }

  async imprimir(): Promise<void> {
    if (this.imprimindo) return;
    this.imprimindo = true;
    try {
      if (this.impressoraSelecionada) {
        try {
          await this.printSvc.imprimirViaQz(
            this.contextoImpressao(),
            this.impressoraSelecionada,
            this.modoImpressaoLocal,
            this.impressoraAtual
          );
          this.qzConectado = true;
          this.mostrarToast(`Etiqueta enviada para ${this.impressoraSelecionada}.`, 'ok');
          return;
        } catch {
          this.qzConectado = false;
          this.mostrarToast('Falha na impressao local. Abrindo o dialogo do navegador.', 'erro');
        }
      }
      try {
        await this.printSvc.imprimirNoNavegador(this.contextoImpressao());
      } catch (e: any) {
        this.mostrarToast(e?.message ?? 'Nao foi possivel preparar a impressao.', 'erro');
      }
    } finally {
      this.imprimindo = false;
    }
  }

  async imprimirPdf(): Promise<void> {
    try {
      await this.printSvc.imprimirPdf(this.contextoImpressao());
    } catch (e: any) {
      this.mostrarToast(e?.message ?? 'Nao foi possivel gerar o PDF.', 'erro');
    }
  }

  // ─── Helpers ───────────────────────────────────────────────────────────────

  colunasParaFonte(fonteName: string | undefined): FonteColuna[] {
    if (!fonteName) return [];
    return [...(this.fontes.find(f => f.nome === fonteName)?.colunas ?? [])].sort((a, b) =>
      a.coluna.localeCompare(b.coluna, 'pt-BR', { sensitivity: 'base', numeric: true })
    );
  }

  labelCampo(campo: EtiquetaCampo): string {
    if (campo.tipo === 'texto_livre') return campo.valor ? `"${campo.valor}"` : '(vazio)';
    if (!campo.coluna) return '(sem coluna)';
    return campo.coluna;
  }

  temDadosReais(fonte: string | undefined): boolean {
    if (!fonte || !this.dadosReais) return false;
    return !!this.dadosReais[fonte.toUpperCase()];
  }

  private dadosPadrao(): EtiquetaDados {
    return {
      logo:    { mostrar: false, alinhamento: 'esquerda', larguraPct: 20, alturaMm: 0, margemTopMm: 0, margemBottomMm: 2 },
      margens: { superior: 1, inferior: 1, esquerda: 1, direita: 1 },
      linhas:  [],
      rotacaoImpressao: 0
    };
  }

  /** Garante compatibilidade com configs antigas que usavam margemMm. */
  private normalizarDados(d: EtiquetaDados): EtiquetaDados {
    if (!d.margens) {
      const v = d.margemMm ?? 1;
      d.margens = { superior: v, inferior: v, esquerda: v, direita: v };
    }
    if (!d.logo) d.logo = this.dadosPadrao().logo;
    d.logo.margemTopMm    = d.logo.margemTopMm    ?? 0;
    d.logo.margemBottomMm = d.logo.margemBottomMm ?? 2;
    for (const linha of d.linhas ?? []) {
      for (const campo of linha.campos ?? []) {
        campo.tipografia = this.tipografiasCampo.some(f => f.valor === campo.tipografia)
          ? campo.tipografia
          : 'Arial';
        campo.fonteZpl = this.fontesZpl.some(f => f.codigo === campo.fonteZpl)
          ? campo.fonteZpl
          : '0';
      }
    }
    d.rotacaoImpressao = this.normalizarRotacao(d.rotacaoImpressao)
      ?? (d.imprimirGirado ? 180 : 0);
    return d;
  }

  private normalizarRotacao(valor: unknown): 0 | 90 | 180 | 270 | null {
    const numero = Number(valor);
    if (!Number.isFinite(numero)) return null;
    const normalizada = ((numero % 360) + 360) % 360;
    return normalizada === 0 || normalizada === 90 || normalizada === 180 || normalizada === 270
      ? normalizada
      : null;
  }

  private novoId(): string {
    return Math.random().toString(36).slice(2, 9);
  }

  private mostrarToast(msg: string, tipo: 'ok' | 'erro'): void {
    this.toast = { msg, tipo };
    setTimeout(() => this.toast = null, 3000);
  }
}
